var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#013177;stroke-miterlimit:10;stroke-width:5.33px;}.cls-2{fill:#33c3ef;}.cls-3{fill:#00a4e3;}.cls-4{fill:#013177;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.5,
    cy: 61.5,
    r: 35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.82,46.87l-7.93-6.19a.63.63,0,0,0-1,.5v3.33A17.88,17.88,0,0,0,43.65,62.35a.63.63,0,0,0,.63.63h4.79a.64.64,0,0,0,.64-.63A11.8,11.8,0,0,1,60.87,50.58v3a.63.63,0,0,0,.35.57.67.67,0,0,0,.67-.07l7.93-6.19a.63.63,0,0,0,.25-.5A.62.62,0,0,0,69.82,46.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.72,61.72H73.93a.64.64,0,0,0-.64.63,11.79,11.79,0,0,1-23.58,0,.64.64,0,0,0-.64-.63H44.28a.63.63,0,0,0-.63.63,17.85,17.85,0,1,0,35.7,0A.63.63,0,0,0,78.72,61.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.36,65.65h-5.6V64.28l1.88-1.91c.54-.56.89-.95,1.06-1.15a2.52,2.52,0,0,0,.34-.53,1.07,1.07,0,0,0,.1-.47.56.56,0,0,0-.2-.47.77.77,0,0,0-.54-.18,1.49,1.49,0,0,0-.74.21,5.24,5.24,0,0,0-.84.62l-1.15-1.34a6.6,6.6,0,0,1,1-.77,3.84,3.84,0,0,1,.89-.35,4.43,4.43,0,0,1,1.07-.12,3.34,3.34,0,0,1,1.34.26,2.16,2.16,0,0,1,.92.76,2,2,0,0,1,.32,1.09,3.11,3.11,0,0,1-.11.84,3.46,3.46,0,0,1-.35.76,4.68,4.68,0,0,1-.64.78c-.26.28-.82.8-1.67,1.57v0h2.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.94,64.16h-.85v1.49H65V64.16H62V62.63l3.22-4.7h1.92V62.6h.85ZM65,62.6v-.9c0-.17,0-.4,0-.68a2.86,2.86,0,0,1,0-.45H65a6.07,6.07,0,0,1-.4.76l-.86,1.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.07,60.65H33.2a.85.85,0,0,0,0,1.7h2.87a.85.85,0,0,0,0-1.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.8,60.65H86.93a.85.85,0,0,0,0,1.7H89.8a.85.85,0,0,0,0-1.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.5,32.36a.83.83,0,0,0-.84.84v2.87a.83.83,0,0,0,.84.84.84.84,0,0,0,.85-.84V33.2A.84.84,0,0,0,61.5,32.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.5,86.09a.83.83,0,0,0-.84.84V89.8a.83.83,0,0,0,.84.84.84.84,0,0,0,.85-.84V86.93A.84.84,0,0,0,61.5,86.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.09,40.89a.85.85,0,0,0-1.2,1.2l2,2a.86.86,0,0,0,.6.24.88.88,0,0,0,.6-.24.85.85,0,0,0,0-1.2Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.08,78.89a.83.83,0,0,0-1.2,0,.86.86,0,0,0,0,1.19l2,2a.89.89,0,0,0,.6.25.87.87,0,0,0,.6-.25.85.85,0,0,0,0-1.2Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.91,40.89l-2,2a.87.87,0,0,0,0,1.2.88.88,0,0,0,.6.24.86.86,0,0,0,.6-.24l2-2a.85.85,0,0,0-1.2-1.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.92,78.89l-2,2a.85.85,0,0,0,0,1.2.85.85,0,0,0,1.2,0l2-2a.85.85,0,0,0-1.2-1.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco5);
export default __webpack_public_path__ + "static/media/ico-5.16a7144d118e9bdf6371e4039acb5194.svg";
export { ForwardRef as ReactComponent };